import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Ensure the app (especially /admin) is never stuck on a stale cached bundle.
// We explicitly register the PWA service worker and periodically check for updates.
import { registerSW } from "virtual:pwa-register";

// Tracking is now initialized via useTracking hook in App.tsx
// This ensures proper React lifecycle and consent management

// PWA update strategy:
// - Check for updates on interval + when tab becomes visible
// - When a new version is available, activate it immediately and reload
if (import.meta.env.PROD) {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      // Activate the new service worker and reload to pick up the latest assets.
      updateSW(true);
    },
    onOfflineReady() {
      // no-op
    },
  });

  const CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1h
  window.setInterval(() => {
    updateSW();
  }, CHECK_INTERVAL_MS);

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      updateSW();
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
